import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { displayName, toAge } from '@virtual-care/isomorphic';

import defaultAvatar from '../../../assets/profile.png';
import { useUser } from '../../firebase';

interface ProfileCardProps {
  className?: string;
}

export default function ProfileCard({ className }: ProfileCardProps) {
  const { data } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const username = displayName(data);

  return (
    <div className={`flex items-center ${className || ''}`}>
      <button
        type="button"
        onClick={() => navigate('/profile')}
        className="group flex cursor-pointer flex-row items-center gap-3 rounded-lg px-4 py-1 transition-colors hover:bg-gray-50 md:flex-row"
      >
        <div className="w-32">
          <p className="truncate text-start text-sm font-medium text-gray-900">
            {username}
          </p>
          {data?.b2cProfile && (
            <p className="text-start text-xs text-gray-500">
              {t('profile.age')}:{' '}
              {toAge(data.b2cProfile) ?? t('common.notSpecified')}
            </p>
          )}
          {!data?.b2cProfile && data?.b2bProfile && (
            <p className="truncate text-start text-xs text-gray-500">
              {t('profile.entity')}: {username}
            </p>
          )}
        </div>
        <img
          src={
            defaultAvatar ||
            `https://api.dicebear.com/5.x/initials/svg?seed=${username}`
          }
          alt={username}
          className="h-10 w-10 rounded-lg object-cover transition-all group-hover:ring-2 group-hover:ring-blue-200 sm:h-12 sm:w-12 md:h-16 md:w-16"
        />
      </button>
    </div>
  );
}
